import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import MoreVert from '@material-ui/icons/MoreVert'
import { Link } from '@material-ui/core';
import Popover from 'antd/lib/popover'
import Grid from '@material-ui/core/Grid'
import Constants from '../common/Constants.json'

import { Link as RouterLink } from 'react-router-dom'
import TelematicsShowButtonsApprovedInstalationsSpa from './TelematicsShowButtonsApprovedInstalationsSpa';

// START - columns for tables with status filter
//*NEW ORDER
export const ColumnsForNewOrderInstalationSpa = (
    [
        {
            name: 'Orden de instalación',
            selector: 'installationOrderId',
            sortable: true,
            width: '250px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Estatus',
            selector: 'statusDesc',
            sortable: true,
            width: '250px',
            cell: row => row.statusDesc
        },
        {
            name: 'Fecha de Instalación',
            selector: 'installationOrderDate',
            sortable: true,
            width: '310px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Fecha de Creación',
            selector: 'createDate',
            sortable: true,
            width: '310px',
            cell: row => row.createDate
        },
        {
            name: "",
            center: true,
            cell: row => (showButtonsNewOrderInstalationSpa(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

export const ColumnsForNewOrderInstalationEng = (
    [
        {
            name: 'Instalation Order',
            selector: 'installationOrderId',
            sortable: true,
            width: '250px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Status',
            selector: 'statusDesc',
            sortable: true,
            width: '250px',
            cell: row => row.statusDesc
        },
        {
            name: 'Instalation Date',
            selector: 'installationOrderDate',
            sortable: true,
            width: '310px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Creation Date',
            selector: 'createDate',
            sortable: true,
            width: '310px',
            cell: row => row.createDate
        },
        {
            name: "",
            center: true,
            cell: row => (showButtonsNewOrderInstalationEng(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

const showButtonsNewOrderInstalationSpa = (row) => {
    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                Detalle de servicio
                            </Link>
                        </div>
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

const showButtonsNewOrderInstalationEng = (row) => {
    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                Service detail
                            </Link>
                        </div>
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

//*APPROVED INSTALATION
export const ColumnsForApprovedInstalationsSpa = (
    [
        {
            name: 'Order de Instalación',
            selector: 'installationOrderId',
            sortable: true,
            width: '200px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Estatus',
            selector: 'statusDesc',
            sortable: true,
            width: '220px',
            cell: row => row.statusDesc
        },
        {
            name: 'Instalador',
            selector: 'installers',
            sortable: true,
            width: '225px',
            cell: row => Object.keys(row.installers).length === 0 ? "Sin instalador asignado": installerName(row)
        },
        {
            name: 'Fecha de Instalación',
            selector: 'installationOrderDate',
            sortable: true,
            width: '230px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Fecha de Creación',
            selector: 'createDate',
            sortable: true,
            width: '230px',
            cell: row => row.createDate
        },
        {
            name: "",
            center: true,
            cell: row => <TelematicsShowButtonsApprovedInstalationsSpa row={row} en={'spa'}/>
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

export const ColumnsForApprovedInstalationsEng = (
    [
        {
            name: 'Installation Order',
            selector: 'installationOrderId',
            sortable: true,
            width: '200px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Status',
            selector: 'statusDesc',
            sortable: true,
            width: '220px',
            cell: row => row.statusDesc
        },
        {
            name: 'Technician',
            selector: 'installers',
            sortable: true,
            width: '225px',
            cell: row => Object.keys(row.installers).length === 0 ? "No installer assigned": installerName(row)
        },
        {
            name: 'Instalation Date',
            selector: 'installationOrderDate',
            sortable: true,
            width: '230px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Creation Date',
            selector: 'createDate',
            sortable: true,
            width: '230px',
            cell: row => row.createDate
        },
        {
            name: "",
            center: true,
            cell: row => <TelematicsShowButtonsApprovedInstalationsSpa row={row} en={'eng'}/>
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

//*PENDING INVOICE
export const ColumnsForPendingInvoiceSpa = (
    [
        {
            name: 'Orden de Instalación',
            selector: 'installationOrderId',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Instalador',
            selector: 'installers',
            sortable: true,
            width: '225px',
            cell: row => Object.keys(row.installers).length === 0 ? "Sin instalador asignado": installerName(row)
        },
        {
            name: 'Fecha de Instalación',
            selector: 'installationOrderDate:',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Fecha de Creación',
            selector: 'createDate',
            sortable: true,
            width: '225px',
            cell: row => row.createDate
        },
        {
            name: 'Estatus',
            selector: 'statusDesc',
            sortable: true,
            width: '225px',
            cell: row => row.statusDesc
        },
        {
            name: "",
            center: true,
            cell: row => (showButtonsPendingInvoiceSpa(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

export const ColumnsForPendingInvoiceEng = (
    [
        {
            name: 'Instalation Order',
            selector: 'installationOrderId',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Technician',
            selector: 'installers',
            sortable: true,
            width: '225px',
            cell: row => Object.keys(row.installers).length === 0 ? "No installer assigned": installerName(row)
        },
        {
            name: 'Instalation Date',
            selector: 'installationOrderDate',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Creation Date',
            selector: 'createDate',
            sortable: true,
            width: '225px',
            cell: row => row.createDate
        },
        {
            name: 'Status',
            selector: 'statusDesc',
            sortable: true,
            width: '225px',
            cell: row => row.statusDesc
        },
        {
            name: "",
            center: true,
            cell: row => (showButtonsPendingInvoiceEng(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

const showButtonsPendingInvoiceSpa = (row) => {
    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                Detalle de servicio
                            </Link>
                        </div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InvoiceReception/${row.branchOfficeID}&${row.installationOrderId}`} >
                                Recepción de facturas
                            </Link>
                        </div>
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

const showButtonsPendingInvoiceEng = (row) => {
    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                Service details
                            </Link>
                        </div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InvoiceReception/${row.branchOfficeID}&${row.installationOrderId}`}>
                                Invoice reception
                            </Link>
                        </div>
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

//*FINALIAZED
export const ColumnsForFinaliazedSpa = (
    [
        {
            name: 'Orden de Instalación',
            selector: 'installationOrderId',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Instalador',
            selector: 'installers',
            sortable: true,
            width: '225px',
            cell: row => Object.keys(row.installers).length === 0 ? "Sin instalador asignado": installerName(row)
        },
        {
            name: 'Fecha de Instalación',
            selector: 'installationOrderDate',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Fecha de Creación',
            selector: 'createDate',
            sortable: true,
            width: '225px',
            cell: row => row.createDate
        },
        {
            name: 'Estatus',
            selector: 'statusDesc',
            sortable: true,
            width: '225px',
            cell: row => row.statusDesc
        },
        {
            name: "",
            center: true,
            cell: row => (showButtonsFinaliazedSpa(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.branchOfficeID
        }
    ]
)

export const ColumnsForFinaliazedEng = (
    [
        {
            name: 'Instalation Order',
            selector: 'installationOrderId',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderId
        },
        {
            name: 'Technician',
            selector: 'installers',
            sortable: true,
            width: '225px',
            cell: row => Object.keys(row.installers).length === 0 ? "No installer assigned": installerName(row)
        },
        {
            name: 'Instalation Date',
            selector: 'installationOrderDate',
            sortable: true,
            width: '225px',
            cell: row => row.installationOrderDate
        },
        {
            name: 'Creation Date',
            selector: 'createDate',
            sortable: true,
            width: '225px',
            cell: row => row.createDate
        },
        {
            name: 'Status',
            selector: 'statusDesc',
            sortable: true,
            width: '225px',
            cell: row => row.statusDesc
        },
        {
            name: "",
            center: true,
            cell: row => (showButtonsFinaliazedEng(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.supplierServiceID
        }
    ]
)

const showButtonsFinaliazedSpa = (row) => {
    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                Detalle de servicio
                            </Link>
                        </div>
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

const showButtonsFinaliazedEng = (row) => {
    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        <div>
                            <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                Service detail
                            </Link>
                        </div>
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

//* Common
const installerName = (row) => {
    return (
        <div>
            {
                row.installers && row.installers.map((item, index) => {
                    return (
                        <Grid item xs={12} key={index}>
                            <Grid container item xs={12}>
                                <Grid item xs={12}>
                                    - {item.name}
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }
                )
            }
        </div>
    )
}